<template>
  <div>
    <div class="row">
      <div
        class="wrapperSmokeCauseDisorders text-left col-sm-10 col-md-8 offset-1"
      >
        <h3
          class="smokeheadlineh3 wow fadeInLeft "
          v-html="$t('smoke_cause_disorders')"
        ></h3>
      </div>
    </div>

    <EnumerationWithArrow
      :arrowFunction="unhide"
      :enumerationStrings="enumerationStrings"
      scrollToArgument="magic"
      style="margin-top:10px;"
    />

    <div class="main" id="section2">{{ "\u00a0" }}</div>

    <div :class="getClassNameFromLamguage">
      <div class="row"></div>
    </div>

    <div id="divBody" class="hidden">
      <div class="wrapperBodyMapImage col-6 offset-6 ">
        <div class="d-md-none"></div>
        <div
          id="image-map-pro-container"
          class="wow fadeIn"
          data-wow-duration="800ms"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { languageAdapter } from "@/services/languageAdapter";
import { loadBodyMap } from "@/services/scripts/bodyMap";
import EnumerationWithArrow from "@/components/EnumerationWithArrow";

export default {
  name: "SmokeInducedSickness",
  components: {
    EnumerationWithArrow
  },
  data() {
    return {
      enumerationStrings: ["asthma", "colic", "nausea"]
    };
  },
  computed: {
    getClassNameFromLamguage() {
      let className = "container-fluid  wow fadeInUpBig  d-none d-md-block";
      className +=
        languageAdapter.getLanguageOfUserFromPath(this.$route.params) === "en"
          ? " factbox_en"
          : " factbox";
      return className;
    }
  },
  methods: {
    unhide() {
      var item = document.getElementById("divBody");
      if (item) {
        item.className = item.className == "hidden" ? "unhidden" : "hidden";
      }
    }
  },
  mounted() {
    loadBodyMap();
  },
  updated() {
    loadBodyMap();
  }
};
</script>
<style scoped>
.wrapperSmokeCauseDisorders {
  margin-bottom: 50px;
}
</style>
